import React from "react";
import { Link } from "react-router-dom";
import useCategories from "../../hooks/useCategories";
import showErrorToast from "../../utilities/Toast/showErrorToast";
import { AdvancedImage } from "@cloudinary/react";
import { cloudinaryInstance } from "../../utilities/Cloudinary/cloudinaryInstance";
import { locale } from "../../utilities/locale/locale";
import localeText from "../../locale";
import Loading from "../../components/Loading/Loading";
import LandingFooter from "../Landing/components/LandingFooter/LandingFooter";
import LandingCopyright from "../Landing/components/LandingCopyright/LandingCopyright";
import useLoadingSimulation from "../Shop/hooks/useLoadingSimulation";
import { Skeleton } from "primereact/skeleton";

const CategoryCardTemplate = ({ category }) => {
  const descriptions = {
    en: category.descriptionEnglish,
    it: category.descriptionItalian,
    pt: category.descriptionPortuguese,
    es: category.descriptionSpanish,
  };
  const description = descriptions[locale] ?? "";

  const handleSelectedCategory = () => {
    window.location.href = `/shop?search=ALL&currency=ALL&type=ALL&seller=ALL&area=ALL&category=${category.id}&page=0&size=12`;
  };
  return (
    <div
      className="category-template flex flex-column justify-content-end relative gap-2 cursor-pointer transition-colors transition-duration-500 border-round-lg"
      onClick={handleSelectedCategory}
      style={{ backgroundColor: "#D9F7EC" }}
    >
      <AdvancedImage
        className="absolute"
        style={{ height: "8rem", top: "-30px", left: "50%", transform: "translateX(-50%)" }}
        cldImg={cloudinaryInstance.image(category.imageid).format("webp")}
      />
      {/*  <div className="" style={{height: "50%"}}></div> */}
      <div className="flex flex-column justify-content-center" style={{ height: "50%" }}>
        <div className="text-center font-semibold" style={{ color: "#204C21" }}>
          {description ? description : category.descriptionEnglish}
        </div>
      </div>
    </div>
  );
};

const CategoriesPage = () => {
  const { categories, loadingCategories } = useCategories({
    onCategoriesError: (code) => showErrorToast({ code }),
  });
  const isLoadingSimulation = useLoadingSimulation();

  return (
    <div className="content-grid bg-white">
      <div className="mt-5 text-sm font-medium" style={{ color: "#7A869A" }}>
        {localeText("departments")} <i className="pi pi-chevron-right text-xs"></i>{" "}
        {localeText("allDepartments")}
      </div>
      <h1 className="title text-2xl font-bold" style={{ color: "#344563" }}>
        {localeText("discoverAllDepartments")}
      </h1>
      <p className="text-sm font-light" style={{ color: "#344563" }}>
        {localeText("seeBellowAllDepartments")}
      </p>
      {loadingCategories ? (
        <>
          <div className="grid grid-nogutter grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 mt-3 mb-8">
            {[...Array(18)].map((_, index) => (
              <Skeleton key={index} size="10rem" />
            ))}
          </div>
        </>
      ) : (
        <div className="grid grid-nogutter grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 mt-3 mb-8">
          {categories.map((category) => (
            <CategoryCardTemplate key={category.id} category={category} />
          ))}
        </div>
      )}

      {/* <Footer /> */}
      <LandingFooter />
      <LandingCopyright />
      <section
        className="md:py-5 full-width"
        style={{ backgroundColor: "#FFFFFF", color: "#7A869A", borderTop: "1px solid #E0E7FF" }}
      >
        <div className="grid gap-3 m-0">
          <div className="col-12 md:col text-center md:text-left">
            <div className="text-sm font-regular">EXTRACONOMY GLOBAL srl</div>
            <div className="text-sm font-regular">Via Nomentana, 1018 - 00137 Roma (IT)</div>
          </div>
          <div className="col-12 md:col text-center md:text-left">
            <div className="text-sm font-regular">P. Iva e C.F. 16948681008 | REA 1686351</div>
          </div>
          <div className="col-12 md:col text-center md:text-right">
            <div className="text-sm font-regular">Privacy Policy</div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CategoriesPage;
